export const navItems = [
  { label: 'Home', link: '/home' },
  { label: 'About Us', link: '/about' },
  { label: 'Our Programs', link: '/programs' },
  { label: 'Admissions', link: '/admissions' },
  { label: 'Our Facility', link: '/facility' },
  { label: 'Impact', link: '/impact' },
  { label: 'Activities', link: '/activities' },
  { label: 'Contact Us', link: '/contact' },
];
  
